import { saveAs } from "file-saver";
import { Component, HostListener, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { AutorizacaoService } from "src/app/services/autorizacao.service";
import printJS from "print-js";

@Component({
  selector: "app-page-visualizar-laudo-publico",
  templateUrl: "./page-visualizar-laudo-publico.component.html",
  styleUrls: ["./page-visualizar-laudo-publico.component.scss"],
})
export class PageVisualizarLaudoPublicoComponent implements OnInit {
  base64Code: string;
  carregando = true;
  erro: string = "";
  zoom = 0.7;
  page = 1;
  incDecZoom = 0.2;

  @HostListener("window:resize")
  setDefaultZoom() {
    this.zoom = window.innerWidth < 1000 ? 1.0 : 0.7;
  }

  constructor(
    private route: ActivatedRoute,
    private autorizacaoService: AutorizacaoService
  ) {}

  ngOnInit(): void {
    this.setDefaultZoom();
    const usuario = this.route.snapshot.params["usuario"];
    const documentoId = this.route.snapshot.params["documentoId"];

    this.autorizacaoService
      .postPdfResultado({ documentoId, Usuario: usuario })
      .subscribe({
        next: (res) => {
          const blob = new Blob([res], { type: "application/pdf" });
          const reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onloadend = () => {
            this.base64Code = reader.result.toString();
            this.carregando = false;
          };
        },
        error: () => {
          this.carregando = false;
          this.erro = "Não foi possível carregar o laudo.";
        },
      });
  }

  imprimir() {
    const base64data = this.base64Code.replace(
      "data:application/pdf;base64,",
      ""
    );
    printJS({ printable: base64data, type: "pdf", base64: true });
  }

  downloadPdf() {
    saveAs(this.base64Code, "relatorio");
  }
}
